import useFetchLocationData from "@rf-l1/map/hooks/useFetchLocationData";
import { useCallback, useContext, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import HCheckArray from "@rf-helper/check-have-value";
import { useMxMapLayoutContext } from "../context/MxMapLayout";
import { useMap } from "@vis.gl/react-google-maps";

interface MxMapObservedUpdateCityAndSectorProps {
  fieldsNames: any;
}
const MxMapObservedUpdateCityAndSector = (
  props: MxMapObservedUpdateCityAndSectorProps
) => {
  const { fieldsNames } = props;
  const { control, setValue } = useFormContext();
  const { customerFetchSearch } = useFetchLocationData();
  const { map_layout } = useMxMapLayoutContext();
  const map = useMap("map");
  const city = useWatch({
    control,
    name: fieldsNames?.city
  });

  const sector = useWatch({
    control,
    name: fieldsNames?.sector || ""
  });

  const UpdateCityAndSector = useCallback(async () => {
    let search = "";
    if (HCheckArray(city)) {
      search += city[0].label;
    }
    if (HCheckArray(sector)) {
      search += ` ${sector[0].label}`;
    }
    const trimmed = search.trim();
    if (!trimmed) {
      map?.setZoom(7.5);
      // No hay datos suficientes para buscar
      return;
    }
    const res = await customerFetchSearch(trimmed);
    // console.debug("customerFetchSearch result:", res);
    if (res) {
      if (fieldsNames?.lat) setValue(fieldsNames?.lat, res.lat);
      if (fieldsNames?.lng) setValue(fieldsNames?.lng, res.lng);
      // if (fieldsNames?.address) setValue(fieldsNames?.address, res.address);
    }

    if (HCheckArray(city) && HCheckArray(sector)) {
      map?.setZoom(15);
    } else if (HCheckArray(city) && !HCheckArray(sector)) {
      map?.setZoom(12);
    } else if (!HCheckArray(city) && !HCheckArray(sector)) {
      map?.setZoom(7.5);
    } else {
      map?.setZoom(7.5);
    }
  }, [city, sector]);

  useEffect(() => {
    if (map_layout.current?.canLoad && (fieldsNames?.city || fieldsNames?.sector)) {
      UpdateCityAndSector();
    }
  }, [city, sector, fieldsNames?.city, fieldsNames?.sector]);

  return null;
};

export default MxMapObservedUpdateCityAndSector;
